import React, { Component } from "react";
import debounce from "lodash.debounce";
import { connect } from "react-redux";
import _ from "i18n";
import {
  initFilterClient,
  setFilterBusinessUnit,
  setFilterClient,
  setFilterClientGroup,
  setFilterCluster,
  setFilterCollaborators,
  setFilterSquads,
  setDynamicTableFilterYear,
  setDynamicTableSearchWord,
  setDynamicTableSortBy,
  setClientType,
  setClientCRMType,
  setClientCRMGroup,
  setCollaboratorRoleGrouped,
  setClosingDateClients,
  setClientsDeletedStatus,
  setCollaboratorBudgetSortBy,
  setVATPeriodicity
} from "Actions";
import {
  fetchCollaboratorSuggestions,
  fetchGroupedCapacityPlaningClients,
  fetchClientSuggestions
} from "Thunks";
import { renderYearsArrayBetween } from "Utils";
import styles from "../../DynamicTable/DynamicTable.local.scss";
import {
  // CLIENT_TYPE_FILTER,
  NEW_COLLABORATOR_ROLE_FILTER,
  COLLABORATOR_ORDER_BUDGET_FILTER,
  CLIENT_GROUP_CRM_FILTER,
  CLOSING_DATE_FOLDER_FILTER,
  CLIENT_CRM_TYPE_FILTER,
  VAT_PERIODICITY,
  DELETED_STATUS
} from "Config";
import TTPFilterHorizontalBar from "../../Common/filters/TTPFilterHorizontalBar";

class GroupedCapacityPlaningClientsFilter extends Component {
  constructor(props) {
    super(props);

    this.loadClientSuggestions = debounce(this.loadClientSuggestions, 1000);

    this.handleSearchInputChange = debounce(this.handleSearchInputChange, 1000);

    this.state = {
      expandedYearsDiv: false
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearsSelect.bind(this)
    );
  }

  setYearsWrapperRef(node) {
    this.wrapperYearsRef = node;
  }

  handleDisplayYearSelectItems = () => {
    let { expandedYearsDiv } = this.state;

    this.setState({ expandedYearsDiv: !expandedYearsDiv });
  };

  handleClickOutsideYearsSelect(event) {
    if (this.wrapperYearsRef && !this.wrapperYearsRef.contains(event.target)) {
      this.setState({ expandedYearsDiv: false });
    }
  }

  renderYearsLabel = () => {
    let { selectedYear } = this.props;

    return selectedYear instanceof Array ? "2021" : selectedYear;
  };

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleResetFilter = () => {
    // TODO
  };

  handleRefreshGroupedCapacityPlaningClients = () => {
    const { dispatch } = this.props;
    dispatch(fetchGroupedCapacityPlaningClients());
  };

  handleClientGroupChange = selected => {
    // let groups = selected.map(element => element.value);
    this.props.dispatch(setFilterClientGroup(selected));
    this.props.dispatch(initFilterClient());
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleClientChange = selected => {
    this.props.dispatch(setFilterClient(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleCollaboratorBudgetSortByChange = selected => {
    this.props.dispatch(setCollaboratorBudgetSortBy(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleCollaboratorChange = selected => {
    // let collaborators = selected.map(element => element.value);
    this.props.dispatch(setFilterCollaborators(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleYearsChange = selected => {
    const { dispatch } = this.props;
    dispatch(setDynamicTableFilterYear(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
    this.props.onAnalyseDateChange &&
      this.props.onAnalyseDateChange(null, selected);
    this.setState({ expandedYearsDiv: false });
  };

  handleSortChange = selected => {
    this.setState(() => {
      this.props.dispatch(setDynamicTableSortBy(selected));
      this.handleRefreshGroupedCapacityPlaningClients();
    });
  };

  handleSquadChange = selected => {
    this.props.dispatch(setFilterSquads(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleClusterChange = selected => {
    this.props.dispatch(setFilterCluster(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleBusinessUnitChange = selected => {
    this.props.dispatch(setFilterBusinessUnit(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleSearchInputChange(word) {
    this.props.dispatch(setDynamicTableSearchWord(word));
    this.handleRefreshGroupedCapacityPlaningClients();
  }

  handleTypeClientChange = selected => {
    this.props.dispatch(setClientType(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleGroupCRMClientChange = selected => {
    this.props.dispatch(setClientCRMGroup(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleTypeCRMClientChange = selected => {
    this.props.dispatch(setClientCRMType(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  //
  handleCollaborateurRoleChange = selected => {
    this.props.dispatch(setCollaboratorRoleGrouped(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleVATPeriodicityChange = selected => {
    this.props.dispatch(setVATPeriodicity(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleClosingDateClientsChange = selected => {
    this.props.dispatch(setClosingDateClients(selected));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  handleSetDeletedStatus = selectedStatus => {
    this.props.dispatch(setClientsDeletedStatus(selectedStatus));
    this.handleRefreshGroupedCapacityPlaningClients();
  };

  loadClientSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchClientSuggestions(searchWord))
      .then(res => {
        let clientsList = res.value.data.data.filter(item => item !== null);
        const clients = clientsList.map(t => {
          return { value: t.id, label: t.name, color: "#000000" };
        });
        callback(clients);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadCollaboratorSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchCollaboratorSuggestions(searchWord))
      .then(res => {
        const collaborators = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.name,
            color: "#000000"
          };
        });
        callback(collaborators);
      })
      .catch(er => {
        callback([]);
      });
  };

  renderYearsSelect = years => {
    const { expandedYearsDiv } = this.state;
    return (
      <div
        ref={this.setYearsWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (expandedYearsDiv === true ? styles.customed_select_opened : "")
        }
      >
        <div className={styles.customed_select_header}>
          <span>{this.renderYearsLabel()}</span>
          <div className={styles.year_actions}>
            <div>
              <span
                className={styles.year_action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i
                  className={
                    expandedYearsDiv === true
                      ? "icon icon-arrow-up"
                      : "icon icon-arrow-down"
                  }
                />
              </span>
            </div>
          </div>
        </div>
        {expandedYearsDiv === true && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {years.map((year, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleYearsChange(year)}
                >
                  {year}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  handleListPageSizeChange = selected => {
    this.props.handleDynamicTablePageSize(selected);
  };

  render() {
    let {
      financialSheetFilter,
      currentOrganization,
      listFilters,
      filter,
      groupedFilter,
      resultCount,
      arrivalYear,
      pageSize
    } = this.props;
    let yearsOption = [];
    let years =
      currentOrganization.startDate && currentOrganization.startDate.date
        ? renderYearsArrayBetween(
            currentOrganization.startDate.date,
            new Date(new Date().setFullYear(new Date().getFullYear() + 1))
          )
        : renderYearsArrayBetween(
            new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
            new Date(new Date().setFullYear(new Date().getFullYear() + 1))
          );
    let filtredYears = years.filter(
      year => (arrivalYear ? year >= arrivalYear : true)
    );
    filtredYears.forEach(item => {
      yearsOption.push({ value: item.toString(), label: item.toString() });
    });

    let filters = [
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("sortBy"),
          options: COLLABORATOR_ORDER_BUDGET_FILTER,
          values: groupedFilter.collaboratorBudgetSortBy.selected,
          action: this.handleCollaboratorBudgetSortByChange
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: financialSheetFilter.client.selected,
          key: financialSheetFilter.clientGroup.selected.length,
          placeholder: _("client"),
          handleChange: this.handleClientChange,
          loadSuggestions: this.loadClientSuggestions,
          values: financialSheetFilter.client.selected
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Type Client (CRM)"),
          options: CLIENT_CRM_TYPE_FILTER,
          values: filter.clientCRMTypes,
          action: this.handleTypeCRMClientChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Groupe Client (CRM)"),
          options: CLIENT_GROUP_CRM_FILTER,
          values: filter.clientCRMGroup,
          action: this.handleGroupCRMClientChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("Collaborateur Role"),
          options: NEW_COLLABORATOR_ROLE_FILTER,
          values: groupedFilter.collaboratorRole.selected,
          action: this.handleCollaborateurRoleChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Régime TVA"),
          options: VAT_PERIODICITY,
          values: groupedFilter.VATPeriodicity,
          action: this.handleVATPeriodicityChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("Date cloture"),
          options: CLOSING_DATE_FOLDER_FILTER,
          values: groupedFilter.closingDate.selected,
          action: this.handleClosingDateClientsChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("clientState"),
          options: DELETED_STATUS,
          values: listFilters.entityClientId.deletedStatus,
          action: this.handleSetDeletedStatus
        }
      }
    ];

    let activatedFilters = [];
    if (groupedFilter.collaboratorRole.selected) {
      activatedFilters.push({
        label: _("selectedRole"),
        value: groupedFilter.collaboratorRole.selected
      });
    }

    return (
      <div className="row align-center medium-12">
        <div className="medium-12">
          <TTPFilterHorizontalBar
            button
            filters={filters}
            customAddOn={this.renderYearsSelect(filtredYears)}
            handleResetFilter={this.handleResetFilter}
            searchPlaceholder="Search by name or erp id"
            searchInputValue={financialSheetFilter.searchWord.searchWord}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            pageSize={pageSize}
            activatedFilter={activatedFilters}
            nbResult={resultCount}
            label={_("folderNumber")}
            marginLeft={"1em"}
            handleListPageSizeChange={this.handleListPageSizeChange}
            cssClass="medium-12"
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  financialSheetFilter: state.financialSheet.periodFilter,
  currentOrganization: state.auth.currentOrganization,
  selectedYear: state.budget.dynamicTable.filter.year,
  filter: state.financialSheet.periodTree.filter,
  groupedFilter: state.capacityPlaning.production.grouped.filter,
  listFilters: state.clients.filter
});

export default connect(mapStateToProps)(GroupedCapacityPlaningClientsFilter);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/GroupedCapacityPlaningClients/GroupedCapacityPlaningClientsFilter.js